export default "/fonts/iu.eot?1e2377c92d9bbfb1b7784e7219f52a43";